<template>
  <section class='leaveStu'>
    <Row>
      <Breadcrumb>
        <BreadcrumbItem to="">食堂消费</BreadcrumbItem>
        <BreadcrumbItem to="">员工列表</BreadcrumbItem>
      </Breadcrumb>
    </Row>
    <Row xs="20" sm="16" md="12" lg="8">

      <Col span='4'>
      <Input v-model="searchParam.notice" placeholder="" />
      </Col>

      <Col span='4'>
      <Button type="info" @click='searchData'>查询</Button>
      <!-- <Button type="warning" style="margin-left: 22px" @click='exportData'>导出员工</Button> -->
      </Col>

    </Row>


    <div style='display:flex;justify-content:space-between;margin-top:20px;'>
      <div id='pdData' class='pdData'>
        <div :class='[curIndex == -1 ? "active" : ""]' class='itempd' @click='tabPD("", -1)'>未分配</div>
        <div :class='[index == curIndex ? "active" : ""]' class='itempd' v-for='(item, index) in departlist'
          :key='item.guid' @click='tabPD(item, index)'>{{ item.name }}</div>

      </div>
      <ul class='conheadRight'>
        <Button type="warning" style="margin-right: 22px" @click='addStaff'>新增员工</Button>
        <!-- <imxls @actionData='getxls' :exportExcelData='exportExcelData' :showxls='showxls' :downUrl='downUrl'></imxls> -->
        <!-- <i-button type="error" @click='batchImport'>批量充值</i-button> -->
      </ul>

    </div>
    <section class='tabelContent'>
      <tablePage border :queryData="queryData" :searchParam='searchParam' :issearch='issearch'></tablePage>
    </section>


    <Modal v-model='showhis' width='800px' style='height:600px' title='消费历史'>
      <tablePage border :queryData="columnshis" :issearch='isshowhis'></tablePage>
    </Modal>
    <Modal v-model='showpay' width='860px' title='充值历史'>
      <tablePage border :queryData="payhis" :issearch='isshowpay'></tablePage>
    </Modal>
    <Modal v-model='addMoney' width='600px' title='充值' @on-ok='updateLesson'>
      <Form :model="formItem" :label-width="50">
        <FormItem label="姓名">
          <Input v-model="formItem.name" disabled placeholder=""></Input>
        </FormItem>
        <FormItem label="账户余额">
          <Input type='number' disabled v-model="formItem.bamount" placeholder=""></Input>
        </FormItem>
        <FormItem label="充值金额">
          <Input type='number' v-model="formItem.amount" placeholder=""></Input>
        </FormItem>
        <FormItem label="备注">
          <Input type='text' v-model="formItem.remark" placeholder=""></Input>
        </FormItem>
      </Form>
    </Modal>
    <Modal v-model="edituser" title='用户修改' width='700px' :mask-closable='false'>
      <Form :model="formItem" :label-width="120">
        <section id='con'>

          <!-- <Form-item label="是否管理员">
                        <RadioGroup v-model="formItem.isadmin">

                          <Radio label="0">否</Radio>
                          <Radio label="1">是</Radio>
                        </RadioGroup>
                      </Form-item> -->
          <Form-item label="是否管理员">
            <RadioGroup v-model="formItem.isadmin">
              <Radio label="1">是</Radio>
              <Radio label="0">否</Radio>
            </RadioGroup>
          </Form-item>

          <Form-item label="是否可用">
            <RadioGroup v-model="formItem.state">
              <Radio label="1">禁用</Radio>
              <Radio label="0">可用</Radio>
            </RadioGroup>
          </Form-item>

        </section>
      </Form>

      <div slot="footer" style='position:relative;clear:both'>

        <Button type="error" @click='removeItem' class='remove' icon="md-trash"
          v-if='this.formItem.id != ""'>注销用户</Button>
        <Button type="default" @click='edituser = false' icon="md-close">取消</Button>
        <Button type="info" @click='postNews(true)' icon="md-checkmark-circle-outline">保存</Button>
      </div>

    </Modal>
    <Modal v-model="editDepart" title='用户企业修改' width='700px' :mask-closable='false'>
      <Form :model="formItem" :label-width="120">
        <section id='con'>
          <Form-item label="请选择企业">
            <RadioGroup v-model="changeDepartid">
              <Radio label="">【企业】</Radio>
              <Radio :label="item.guid" v-for='(item, index) in departlist' :key='item.guid'>{{ item.name }}</Radio>
            </RadioGroup>
          </Form-item>

        </section>
      </Form>

      <div slot="footer" style='position:relative;clear:both'>


        <Button type="default" @click='editDepart = false' icon="md-close">取消</Button>
        <Button type="info" @click='changeDepartMethod' icon="md-checkmark-circle-outline">保存</Button>
      </div>

    </Modal>
    <Modal v-model="editCard" title='用户身份证修改' width='700px' :mask-closable='false'>
      <Form :model="formItem" :label-width="120">
        <section id='con'>
          <Form-item label="身份证：">
            <Input type='text' v-model="usercard" placeholder=""></Input>
          </Form-item>

        </section>
      </Form>

      <div slot="footer" style='position:relative;clear:both'>


        <Button type="default" @click='editCard = false' icon="md-close">取消</Button>
        <Button type="info" @click='changeCardMethod' icon="md-checkmark-circle-outline">保存</Button>
      </div>

    </Modal>
    <Modal v-model="addStaffModal" title='用户身份证修改' width='700px' :mask-closable='false'>
      <Form :model="formItem" :label-width="120">
        <section id='con'>
          <Form-item label="姓名">
            <Input type='text' v-model="username" placeholder=""></Input>
          </Form-item>
          <Form-item label="身份证号：">
            <Input type='text' v-model="usercard" placeholder=""></Input>
          </Form-item>
          <Form-item label="手机号：">
            <Input type='text' v-model="userphone" placeholder=""></Input>
          </Form-item>
          <Form-item label="所属支部">
            <RadioGroup v-model="userdepart">
              <Radio :label="item.guid" v-for='(item, index) in departlist' :key='item.guid'>{{ item.name }}</Radio>
            </RadioGroup>
          </Form-item>
        </section>
      </Form>

      <div slot="footer" style='position:relative;clear:both'>


        <Button type="default" @click='addStaffModal = false' icon="md-close">取消</Button>
        <Button type="info" @click='addStaffMethod' icon="md-checkmark-circle-outline">保存</Button>
      </div>

    </Modal>
  </section>
</template>

<script>
import getDates from '../utils/index'
import tablePage from './tablePage'
import bemodal from './formItem'
import utils from '../utils/index'
import imxls from './imXLSNewTemp'
export default {
  name: 'noticelist',
  components: {
    tablePage,
    bemodal,
    imxls
  },
  data () {
    return {
      addStaffModal: false,
      usercard: '',
      username: '',
      userphone: '',
      userdepart: '',
      editCard: false,
      showxls: false,
      exportExcelData: {
        excelTitle: '员工充值模板',
        thead: ['姓名', '电话', '金额', '备注'],
        filterVal: ['name', 'phone', 'amount', 'remark'],
        // mockData:['张三',  '17710582636', '22', '5月份饭卡钱'],
        mockData: [],
        curUrl: 'canteenAmountRecord/saveBatch',
        downUrl: '',
      },
      downUrl: '',
      editDepart: false,
      changeDepartid: '',
      unionid: '',
      changeDepartUnionid: '',
      edituser: false,
      departlist: [],
      curIndex: 0,
      formItem: {
        name: '',
        amount: 0,
        schoolid: -1,
        userid: -1,
        departid: '',
        remark: '',
        flag: 'teach',
        openid: '',
      },
      addMoney: false,
      hisData: '',
      columnshis: [],
      showhis: false,
      showpay: false,
      smodal: false,
      reloadTmep: -1,
      initformData: [],
      payhis: [
        '',
        [{
          title: '姓名',
          key: 'name',
          align: 'center',
        },
        {
          title: '充值前',
          key: 'bamount',
          align: 'center',
          width: '120px'
        },
        {
          title: '充值',
          key: 'amount',
          align: 'center',
          width: '120px'
        },
        {
          title: '充值后',
          key: '',
          align: 'center',
          width: '100px',
          render: (h, params) => {
            var item = params.row
            return h('span', item.bamount + item.amount)
          }
        },

        {
          title: '充值时间',
          key: 'addtime',
          align: 'center',
          width: '180px',
          render: (h, params) => {
            var item = params.row.addtime
            item = item.split('.')[0]
            item = item.split('2021-')
            return h('span', item)
          }
        },
        {
          title: '备注',
          key: 'remark',
          align: 'center',
          width: '200px'
        },
        ]
      ],
      columnshis: [
        'canteenRecord/getQueryList',
        [{
          title: '姓名',
          key: 'name',
          align: 'center',
        },
        {
          title: '消费金额',
          key: 'amount',
          align: 'center',
          width: '100px'
        },
        {
          title: '消费方式',
          key: 'addusername',
          align: 'center',
          width: '100px',
          render: (h, params) => {
            var item = params.row.type
            if (item == 1) {
              return h('span', '人脸')
            } else {
              return h('span', '扫码')
            }
          }
        },
        {
          title: '设备名称',
          key: 'devicename',
          align: 'center',
          width: '200px'
        },
        {
          title: '消费时间',
          key: 'addtime',
          align: 'center',
          width: '200px'
        },
        ]
      ],
      queryData: ['',
        [{
          title: '姓名',
          key: '',
          width: 200,
          ellipsis: true,
          render: (h, params) => {
            var pic = params.row.imgurl ? params.row.imgurl : ''
            var _firstLetter = ''
            if (params.row.name) {
              _firstLetter = params.row.name.substr(0, 1)
            }
            var _zd = {
              style: {
                color: "#ed4c78",
                backgroundColor: "rgba(237,76,120,.1)",
                padding: "2px 8px",
                borderRadius: '7px',
                fontSize: '11px',
                display: 'inline-block',
                marginRight: '4px',
              }
            }
            var _isno = ''
            if (params.row.state == 1) {
              _isno = h('span', _zd, '已禁用')
            }
            if (pic) {
              return h('viewer', [
                h('img', {
                  style: {//设置样式
                    display: 'inline-block',
                    width: '30px',
                    height: '30px',
                    borderRadius: '50%',
                    textAlign: 'center',
                    lineHeight: '30px',
                    position: 'absolute',
                  },
                  attrs: {//设置属性
                    src: pic
                  }
                }),
                h('span', {
                  style: {
                    fontWeight: 'bold',
                    width: '30px',
                    height: '30px',
                    paddingLeft: '45px',
                    lineHeight: '30px',
                  },
                }, params.row.name || ''),
                _isno
              ]
              )
            } else {
              return h('div', [
                h('span', {

                  style: {
                    display: 'inline-block',
                    width: '30px',
                    height: '30px',
                    background: 'rgba(237,76,120,.1)',
                    borderRadius: '50%',
                    textAlign: 'center',
                    lineHeight: '30px',
                    color: '#ed4c78',
                    position: 'absolute',

                  },
                }, _firstLetter),
                h('span', {
                  style: {
                    fontWeight: 'bold',
                    width: '30px',
                    height: '30px',
                    paddingLeft: '45px',
                    lineHeight: '30px',
                  },
                }, params.row.name),
                _isno
              ])
            }
          }
        },
        {
          title: '所属企业',
          key: 'departname',
          align: 'center',
          render: (h, params) => {
            var partname = params.row.departname ? params.row.departname : '未加入企业'
            return h('div', [
              h('span', {
                style: {
                  textDecoration: 'underline',
                  color: '#2d8cf0',
                  cursor: 'pointer'
                },
                on: {
                  click: () => {
                    console.log(params.row)

                    this.changeDepartid = params.row.departid
                    this.changeDepartUserid = params.row.guid
                    this.changeDepartUnionid = params.row.unionid
                    this.changeDepart()
                  }
                }
              }, partname),
            ]);
          }
        },
        {
          title: '手机号码',
          key: 'phone',
          align: 'center',
        },

        {
          title: '身份证号',
          key: 'departname',
          align: 'center',
          render: (h, params) => {
            var _cardno = params.row.cardno ? params.row.cardno : '点此绑定身份证'
            return h('div', [
              h('span', {
                style: {
                  textDecoration: 'underline',
                  color: '#2d8cf0',
                  cursor: 'pointer'
                },
                on: {
                  click: () => {
                    console.log(params.row)
                    this.usercard = params.row.cardno || ''
                    this.changeDepartUserid = params.row.guid
                    this.changeDepartUnionid = params.row.unionid
                    this.bindCard()
                  }
                }
              }, _cardno),
            ]);
          }
        },
        {
          title: '',
          slot: 'action',
          width: 100,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('span', {
                style: {
                  display: 'inline-block',
                  width: '60px',
                  height: '25px',
                  background: '#2db7f5',
                  borderRadius: '6px',
                  textAlign: 'center',
                  lineHeight: '25px',
                  color: '#fff',
                  fontSize: '12px',
                  cursor: 'pointer',
                  userSelect: 'none'
                },
                on: {
                  click: () => {


                    this.curStuInfo = params.row

                    this.getId(params.row.guid)


                  }
                }
              }, '编辑')
            ])
            // <span class='do' @click="show(index,row)">编辑</span>
          }
        },
        ]
      ],
      searchParam: {
        notice: '',
      },
      issearch: -1,
      isshowpay: -1,
      isshowhis: -1,
      userInfo: {},
      curGuid: '',
    }
  },
  mounted () {

    this.userInfo = JSON.parse(localStorage.getItem('inchUserinfo'))
    this.getDepart()
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.tagName === 'INPUT') {
        e.preventDefault();
      }
    });
  },
  methods: {
    addStaff () {
      console.log(this.curItem)
      this.userdepart = this.curItem['guid']
      this.addStaffModal = true
    },
    addStaffMethod () {
      console.log()
      var that = this
      var param = {
        name: this.username,
        nickname: this.username,
        phone: this.userphone,
        guid: '',
        departid: this.userdepart,
        cardno: this.usercard,
        state: 0,
      }
      if (this.userphone == '') {
        that.$Message.error('请填写手机号')
        return false;
      }
      this.axios.post('appUser/save', param).then(res => {
        if (res.success) {
          that.$Message.info(res.msg)
          that.searchData()
          that.addStaffModal = false
        } else {
          that.$Message.error(res.msg)
        }
      })
    },
    bindCard () {
      this.editCard = true
    },
    batchImport () {
      var that = this
      var _curUrl = 'appUser/dataList?length=-1&nickstate=-1&departstatus=1&departid=' + this.curItem.guid
      this.axios.get(_curUrl, { params: {} }).then(res => {
        console.log(res, 'res')

        if (res.data && res.data.length > 0) {
          that.downUrl = _curUrl
          that.showxls = true
        } else {
          that.$Message.info('该企业下没有人员')
        }
        // that.showxls=true
      })
    },
    getxls (grade) {
      var that = this
      that.searchData()
      that.showxls = false
    },
    changeDepart () {
      this.editDepart = true
    },
    changeCardMethod () {
      var that = this
      var param = {
        cardno: this.usercard,
        guid: this.changeDepartUserid,
        unionid: this.changeDepartUnionid
      }


      this.axios.post('appUser/updateCardno', param).then(res => {
        if (res.success) {
          that.$Message.info(res.msg)
          that.reloadTable()
          that.editCard = false
        } else {
          that.$Message.error(res.msg)
        }
      })
    },
    changeDepartMethod () {
      console.log(this.changeDepartid)
      var that = this
      var param = {
        departid: this.changeDepartid,
        guid: this.changeDepartUserid,
        unionid: this.changeDepartUnionid
      }


      this.axios.post('appUser/changeDepart', param).then(res => {
        if (res.success) {
          that.$Message.info(res.msg)
          that.reloadTable()
          that.editDepart = false
        } else {
          that.$Message.error(res.msg)
        }
      })
    },
    postNews () {
      var that = this
      var param = {
        isadmin: this.formItem.isadmin,
        state: this.formItem.state,
        guid: this.formItem.guid,
        openid: this.formItem.openid,
      }
      console.log(param, 'parm')

      this.axios.post('appUser/save', param).then(res => {
        if (res.success) {
          that.$Message.info(res.msg)
          that.reloadTable()
          that.edituser = false
        } else {
          that.$Message.error(res.msg)
        }
      })
    },
    updateLesson () {
      console.log(this.formItem)
      var that = this
      if (this.formItem.amount != 0) {

        this.axios.post('canteenAmountRecord/save', this.formItem).then((a) => {
          if (a.success) {
            that.$Message.info(a.msg)
            that.issearch = Math.random()
            that.formItem = {
              name: '',
              remark: '',
              departid: '',
              amount: 0,
              schoolid: -1,
              userid: -1,
              openid: '',
            }
          }
        })
      }

    },
    removeItem () {
      var that = this
      this.$Modal.confirm({
        title: '提示',
        content: '<p>是否确认删除？</p>',
        onOk: () => {
          //console.log(that.curStuInfo)
          var param = {
            id: that.curStuInfo.guid,
            // unionid: 'ogdvn7T2L_vT-X7nSiAMHU7KAESM' || that.curStuInfo.openid,
            // unionid: that.curStuInfo.openid,
          }

          that.axios.post('appUser/delete', param).then(res => {
            if (res.success) {
              that.$Message.info(res.msg)
              that.reloadTable()
              that.edituser = false
            } else {
              that.$Message.error(res.msg)
            }
          })
        },
        onCancel: () => {

        }
      });
    },
    exportData () {
      // student/exportNoFace

      var tHeader = ["姓名", "所属企业", "手机号", "账户余额（元）"]
      var filterVal = ['name', 'departname', 'phone', 'amount']

      utils.exportExcel('appUser/dataList?nickstate=-1&departstatus=1&departid=' + this.curItem['guid'], {}, this.curItem['name'], tHeader, filterVal)
    },
    getDepart () {

      var that = this


      this.axios.get('dic/getQueryList', { params: { rootid: 'depart', pid: 0, length: -1 } }).then((a) => {
        console.log(a, 'a')
        that.curItem = a['data'][0]
        that.departlist = a.data
        that.queryData[0] = 'appUser/dataList?nickstate=-1&departstatus=1&departid=' + that.curItem['guid']
        that.searchData()
      })

    },
    getId (id) {
      var that = this
      this.formItem = {
        state: '0',
        isadmin: '0',
        guid: '',
        openid: '',
      }
      this.lanmu = []
      this.mewsto = []
      this.edituser = true
      that.treekey = Math.random()
      if (id != -1) {
        this.isnewModal = false
        this.axios.get('appUser/getId', { params: { guid: id } }).then(res => {
          //console.log(res)
          that.formItem.state = String(res.data.state)
          that.formItem.isadmin = String(res.data.isadmin)
          that.formItem.guid = res.data.guid
          that.formItem.openid = res.data.openid
        })
      }

    },
    tabPD (item, index) {
      console.log(item, index)
      var that = this
      this.curIndex = index
      if (item != '') {
        this.curItem = item

      }
      var _guid = item.guid ? item['guid'] : ''
      that.queryData[0] = 'appUser/dataList?nickstate=-1&departstatus=1&departid=' + _guid
      that.searchData()
    },
    getHisData (name, row) {
      this.showhis = true
      this.isshowhis = Math.random()
      var url = this.columnshis[0].split("?")[0]
      this.columnshis[0] = url + '?name=' + name
    },
    getPayData (name, row) {
      console.log(row, 'row')
      this.showpay = true
      this.isshowpay = Math.random()
      var url = this.payhis[0].split("?")[0]
      // this.payhis[0] = url+'?name='+name
      this.payhis[0] = url + '?userid=' + row.guid
    },
    searchData () {
      this.issearch = Math.random()
    },
    reloadTable () {
      this.issearch = Math.random()
    },
  }
}
</script>

<style scoped>
.tabelContent {
  margin-top: 20px;
}

.leaveStu {
  flex: 1;
  padding-right: 25px !important;
  /* overflow: scroll; */
  padding-bottom: 50px;
  padding-top: 20px;
  overflow-x: hidden;
}

.leaveStu .ivu-row:first-of-type {
  margin-top: 5px;
}

.leaveStu .ivu-row {
  margin-top: 20px;
  /* 	overflow:hidden; */
  position: relative;
}

.leaveStu .ivu-col {
  margin-right: 10px;
  /* float:left; */
}

.leaveStu .ivu-col:last-of-type {
  float: left;
  margin-left: 0px;
  /* position:absolute;
		right:0px; */
}

.demo-upload-list {



  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  overflow: hidden;
  margin-right: 4px;
  margin-bottom: 5px;
}

.demo-upload-list img {
  width: 40px;
  height: 40px;
  float: left;
  margin-right: 15px;
}

.demo-upload-list span {
  line-height: 40px;
  font-size: 12px;
  float: left;
}

.demo-upload-list-cover {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, .6);
}

.demo-upload-list:hover .demo-upload-list-cover {
  display: block;
}

.demo-upload-list-cover i {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 10px;
  line-height: 40px;

}

#hwSchool {
  position: relative;
}

#hwSchool .ivu-tree {
  position: absolute;
  top: 33px;
  left: 0px;
  background: #fff;
  z-index: 1000;
  width: 300px;
  height: 300px;
  border: 1px solid #dcdee2;
  border-top: 0 none;
  overflow-y: scroll;
  overflow-x: hidden;
  padding-left: 10px;
}

.modalUl {
  width: 100%;
  display: flex;
  justify-content: space-between;


}

.modalUl li {
  list-style: none;

}

.modalUl>li:first-of-type {
  width: 35%;
  height: 100%;
  height: 400px;
  overflow-y: scroll;
  overflow-x: hidden;
}

.modalUl>li:last-of-type {
  flex: 1;
  padding-left: 30px;
}

.treeContent {}

.hwImgCon {
  margin-top: 10px;

}

.hwImgCon img {
  width: 55px;
  height: 55px;
  border-radius: 5px;
}

.conheadRight {
  display: flex;
  justify-content: space-between
}

.pdData {
  display: flex;
  justify-content: flex-start;
  list-style: none;
  flex-wrap: wrap;
}

.itempd {
  height: 32px;
  line-height: 32px;
  border-radius: 20px;
  padding: 0 15px;
  font-size: 14px;
  margin-right: 10px;
  cursor: pointer
}

.itempd.active {
  background-color: #00d186;
  border-color: #00d186;
  color: #fff;
}

.remove {
  float: left;
}
</style>
